/*
 * - Stores paths for the file storage service endpoints
 */

const serviceRoot = 'api/FileStorage/';

export const FileStorageEndpoints = {
  // Queries ---------------------------------------------------------------------------------------
  getUserFilesDetails: () => `${serviceRoot}getUserFilesDetails`,

  // Mutations -------------------------------------------------------------------------------------
  uploadPnAttachments: () => `${serviceRoot}uploadPublicNoticeAttachments`,
  uploadFiles: () => `${serviceRoot}uploadFiles`,
  downloadFile: () => `${serviceRoot}downloadFile`,
  deleteFile: () => `${serviceRoot}deleteDraftFile`,
};
